import React from 'react';
import PropTypes from 'prop-types';
import InputsUnit from '../../../../../../../../../../../../components/UIComponents/Fields/InputsUnit2';
import optionsLengthUnits from '../../../../../../../../../../../../utils/units/optionsLengthUnits2';

const TSection = ({
  sectionType,
  sections,
  changeGeometry
}) => {
  return (
    <div>
      <InputsUnit
        label={sections.listSectionTypes.tSection.inputs.b.text}
        inputName="sections.listSectionTypes.tSection.inputs.b.value"
        selectList={optionsLengthUnits}
        selectName="sections.listSectionTypes.tSection.inputs.b.unit"
        tooltipDescription={sections.listSectionTypes.tSection.inputs.b.description}
        tooltipTarget={sections.listSectionTypes.tSection.inputs.b.name}
        onChange={(e) => {
          const val = e.target.value;
          changeGeometry(sections.listSectionTypes.tSection.inputs, sectionType, val, sections.listSectionTypes.tSection.inputs.b.name);
        }}
      />
      <InputsUnit
        label={sections.listSectionTypes.tSection.inputs.h.text}
        inputName="sections.listSectionTypes.tSection.inputs.h.value"
        selectList={optionsLengthUnits}
        selectName="sections.listSectionTypes.tSection.inputs.h.unit"
        tooltipDescription={sections.listSectionTypes.tSection.inputs.h.description}
        tooltipTarget={sections.listSectionTypes.tSection.inputs.h.name}
        onChange={(e) => {
          const val = e.target.value;
          changeGeometry(sections.listSectionTypes.tSection.inputs, sectionType, val, sections.listSectionTypes.tSection.inputs.h.name);
        }}
      />
      <InputsUnit
        label={sections.listSectionTypes.tSection.inputs.b0.text}
        inputName="sections.listSectionTypes.tSection.inputs.b0.value"
        selectList={optionsLengthUnits}
        selectName="sections.listSectionTypes.tSection.inputs.b0.unit"
        tooltipDescription={sections.listSectionTypes.tSection.inputs.b0.description}
        tooltipTarget={sections.listSectionTypes.tSection.inputs.b0.name}
        onChange={(e) => {
          const val = e.target.value;
          changeGeometry(sections.listSectionTypes.tSection.inputs, sectionType, val, sections.listSectionTypes.tSection.inputs.b0.name);
        }}
      />
      <InputsUnit
        label={sections.listSectionTypes.tSection.inputs.h0.text}
        inputName="sections.listSectionTypes.tSection.inputs.h0.value"
        selectList={optionsLengthUnits}
        selectName="sections.listSectionTypes.tSection.inputs.h0.unit"
        tooltipDescription={sections.listSectionTypes.tSection.inputs.h0.description}
        tooltipTarget={sections.listSectionTypes.tSection.inputs.h0.name}
        onChange={(e) => {
          const val = e.target.value;
          changeGeometry(sections.listSectionTypes.tSection.inputs, sectionType, val, sections.listSectionTypes.tSection.inputs.h0.name);
        }}
      />
    </div>
  );
};

export default TSection;
